var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEstacionCargaDentro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255.12 224.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#168e16;}.cls-2{fill:#040006;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-estacion-carga-dentro") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_38_copia",
    "data-name": "38 copia"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.26,190.25c-11.82,0-23.75-6.86-23.75-22.19,0-7.92,4.56-13.83,8.22-18.59.56-.74,1.13-1.47,1.67-2.2,3.7-5.06,6.5-9.75,6.53-9.8l4.2-7.07a3.62,3.62,0,0,1,6.12-.17l4.59,6.82c0,.06,3.63,5.4,7.4,10.72l.84,1.18c3.65,5.1,8.18,11.44,8.18,19.76C123.26,181.79,113.84,190.25,99.26,190.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.73,36.68H65.56a6.39,6.39,0,0,0-6.39,6.39v48.1a6.39,6.39,0,0,0,6.39,6.39h68.17a6.39,6.39,0,0,0,6.39-6.39V43.07A6.39,6.39,0,0,0,133.73,36.68Zm-6.39,48.1H72V49.46h55.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.73,56.4H222.66c-1.31,0-4.78,0-7.27,2.68s-2.21,5.82-2.06,7.94c.06.73.11,1.49.11,2.35v75.78c0,2.17-.57,13-11.77,13-11.74,0-14.2-7.25-14.2-13.34V119.41c0-2.56,0-6.84-3.13-10a9.93,9.93,0,0,0-7.24-2.83h-10V6.39A6.39,6.39,0,0,0,160.72,0H38.23a6.39,6.39,0,0,0-6.39,6.39V212H6.39a6.39,6.39,0,1,0,0,12.78H191.17a6.39,6.39,0,1,0,0-12.78H167.11V119.36h7.58V144.8c0,12,7.06,26.12,27,26.12,19.42,0,24.55-16.86,24.55-25.77v-76h22.51a6.4,6.4,0,0,0,0-12.79ZM44.62,12.78H154.33v199H44.62Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEstacionCargaDentro);
export default __webpack_public_path__ + "static/media/ic-estacion-carga-dentro.34020fec02c3fc1641013fde6e29c633.svg";
export { ForwardRef as ReactComponent };